import Api from "@/services/Api";

export default {
	async all(caseId) {
		return Api().get(`/tls/customer_service/cases/${caseId}/comments`, {
			params: {
				limit: 100
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async create({ caseId, message }) {
		const data = new FormData();
		const url  = `/tls/customer_service/cases/${caseId}/comments`;

		data.set("comment[message]", message);

		return Api()({
			method: "post",
			url: url,
			data: data
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async destroy(caseId, id) {
		return Api().delete(`/tls/customer_service/cases/${caseId}/comments/${id}`)
			          .then(response => response.data)
			          .catch(error => Promise.reject(error));
	},
};